import { ActionTree, ActionContext } from 'vuex'
import { RootState, useStore } from '@/store'
import { state, UserState } from './state'
import { Mutations } from './mutations'
import { UserMutationTypes } from './mutation-types'
import { UserActionTypes } from './action-types'
import { loginRequest, userInfoRequest, loginOutRequest } from '@/apis/user'
// import { removeToken, setToken } from '@/utils/cookies'
import { PermissionActionType } from '../permission/action-types'
import router, { resetRouter } from '@/router'
import { RouteRecordRaw } from 'vue-router'
import { NotificationActionTypes } from '../notification/action-types'
interface TokenResponse {
  active: boolean;
  token: string;
  id: any;
}

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<UserState, RootState>, 'commit'>

export interface Actions {
  [UserActionTypes.ACTION_LOGIN](
    { commit }: AugmentedActionContext,
    userInfo: { username: string; password: string }
  ): Promise<TokenResponse>;

  [UserActionTypes.ACTION_RESET_TOKEN](
    { commit }: AugmentedActionContext
  ): void;
  [UserActionTypes.ACTION_GET_USER_INFO](
    { commit }: AugmentedActionContext
  ): void;
  [UserActionTypes.ACTION_CHANGE_ROLES](
    { commit }: AugmentedActionContext, role: string
  ): void;
  [UserActionTypes.ACTION_LOGIN_OUT](
    { commit }: AugmentedActionContext,
  ): void;
}

export const actions: ActionTree<UserState, RootState> & Actions = {

  async [UserActionTypes.ACTION_LOGIN](
    { commit }: AugmentedActionContext,
    userInfo: { username: string; password: string; verifyCode: string; id: string; rememberMe: boolean }
  ): Promise<TokenResponse> {
    let { username, password, verifyCode, id, rememberMe = false } = userInfo
    username = username.trim()

    return new Promise<TokenResponse>((resolve, reject) => {
      loginRequest({ username, password, verifyCode, id, rememberMe }).then((res: any) => {
        if (res) {
          // setToken(res.token)
          commit(UserMutationTypes.SET_TOKEN, res.token)
          resolve(res)
        }
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },

  [UserActionTypes.ACTION_RESET_TOKEN](
    { commit }: AugmentedActionContext) {
    console.log('resetToken')
    // removeToken()
    commit(UserMutationTypes.SET_TOKEN, '')
    commit(UserMutationTypes.SET_ROLES, [])
    commit(UserMutationTypes.SET_USERID, 0)
  },

  async [UserActionTypes.ACTION_GET_USER_INFO](
    { commit }: AugmentedActionContext
  ) {
    // if (state.token === '') {
    //   throw Error('token is undefined!')
    // }
    await userInfoRequest().then((res: any) => {
      if (res) {
        commit(UserMutationTypes.SET_ROLES, res.roles.length ? res.roles : ['admin'])
        commit(UserMutationTypes.SET_USERNAME, res.username)
        commit(UserMutationTypes.SET_NAME, res.name)
        commit(UserMutationTypes.SET_AVATAR, res.avatar)
        commit(UserMutationTypes.SET_INTRODUCTION, res.introduction)
        commit(UserMutationTypes.SET_EMAIL, res.email)
        commit(UserMutationTypes.SET_USERID, res.id)
        return res
      } else {
        throw Error('Verification failed, please Login again.')
      }
    })
  },

  async [UserActionTypes.ACTION_CHANGE_ROLES](
    { commit }: AugmentedActionContext,
    role: string
  ) {
    const token = role + '-token'
    const store = useStore()
    commit(UserMutationTypes.SET_TOKEN, token)
    // setToken(token)
    await store.dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined)
    store.dispatch(PermissionActionType.ACTION_SET_ROUTES, state.roles)
    store.state.permission.dynamicRoutes.forEach((item: RouteRecordRaw) => {
      router.addRoute(item)
    })
  },

  async [UserActionTypes.ACTION_LOGIN_OUT](
    { commit }: AugmentedActionContext
  ) {
    console.log('loginOut')
    // removeToken()
    await loginOutRequest()
    commit(UserMutationTypes.SET_USERID, 0)
    commit(UserMutationTypes.SET_TOKEN, '')
    commit(UserMutationTypes.SET_ROLES, [])
    resetRouter()
    const store = useStore()
    store.dispatch(NotificationActionTypes.ACTION_CLOSE_WEBSOCKET, undefined)
  }
}

